import type { AgentStoredFile } from './agentClient';
import type { ExcelFile } from '../types/excel';

function normalizePath(path?: string): string | null {
  if (!path) return null;

  const normalized = path
    .trim()
    .replace(/\\/g, '/')
    .replace(/\/+/g, '/')
    .replace(/\/$/, '');

  return normalized ? normalized.toLowerCase() : null;
}

/**
 * Busca un archivo ya guardado en el agente usando primero la ruta relativa
 * persistida y luego la ruta absoluta previa. Evita reutilizar por nombre
 * solamente para no mezclar archivos distintos con el mismo nombre.
 */
export function findMatchingAgentFile(
  file: Pick<ExcelFile, 'filePath' | 'relativePath'>,
  agentFiles: AgentStoredFile[]
): AgentStoredFile | null {
  const relativePath = normalizePath(file.relativePath);
  if (relativePath) {
    const relativeMatch = agentFiles.find(
      (agentFile) => normalizePath(agentFile.relativePath) === relativePath
    );
    if (relativeMatch) {
      return relativeMatch;
    }
  }

  const absolutePath = normalizePath(file.filePath);
  if (!absolutePath) {
    return null;
  }

  return (
    agentFiles.find((agentFile) => normalizePath(agentFile.path) === absolutePath) || null
  );
}
